export const getRedirectPath = ({ role, userId, search }: { role: string; userId?: string; search: string }) => {
  const params = new URLSearchParams(search);
  const rawRedirect = params.get("redirect");

  // Default role-based redirect
  let redirectPath = redirectByRole(role);

  // Client-specific report redirect
  if (role === "Client" && rawRedirect?.startsWith("/report")) {
    const parts = rawRedirect.split("/");
    const clientIdEncoded = parts[4];

    try {
      const clientId = atob(clientIdEncoded);

      if (clientId === String(userId)) {
        redirectPath = rawRedirect;
      }
    } catch (e) {}
  }

  return redirectPath;
};

export const redirectByRole = (role: string) => {
  switch (role) {
    case "Admin":
      return "/admin-dashboard";
    case "User":
      return "/user-dashboard";
    case "Client":
      return "/client-dashboard";
    case "Employee":
      return "/employee-dashboard";
    default:
      return "/dashboard";
  }
};
